//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'AppsContent',

    props: ['apps', 'version', 'loaded'],

    data(){ return {
        showButtonArea: 0,
        showName: 1,
    }},

    methods: {
        move(item){
            let url = item.url

            if(url)
            window.location = url
        }
    }
}
